import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import LocationPopup from "./component";
import { fetchPincodeSearchDetails, searchCityApi } from "./actions";
import { fetchCityByCityId, setLocationSelectionType } from "../location-picker-popup/actions";
import { setShowPopularCitiesOnHomepage } from "../buy-used-car/actions";

const mapStateToProps = ({
    cities: {
        selectedCity
    },
    locationPicker: {
        isC2bLocationPicker,
        autoFocusSearch
    },
    user: {
        userId
    }
}
) => ({
    selectedCity,
    isC2bLocationPicker,
    userId,
    autoFocusSearch
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchPincodeSearchDetailsConnect: fetchPincodeSearchDetails,
    setLocationSelectionTypeConnect: setLocationSelectionType,
    setShowPopularCitiesOnHomepageConnect: setShowPopularCitiesOnHomepage,
    searchCityApiConnect: searchCityApi,
    fetchCityByCityIdConnect: fetchCityByCityId
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LocationPopup);
